import { styled } from 'stitches.config'

export const BubblehouseContainer = styled('div', {
  width: '100%',
})
